<template>
  <div>
    <van-row>
      <van-sticky offset-top="1.22016rem">
        <van-col span="20">
          <van-tabs class="div-tab" :border="false" @click="onChange">
            <van-tab
              v-for="(item, index) in tabList"
              :key="index"
              :title="item.leftTopTip"
              :name="item.checkStatus || ''"
              :info="getStatusCount(item.statusCount)"
            ></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="4">
          <div class="sbar-2" @click="modeShowFun">
            筛选
            <img src="@/assets/image/filter.png" alt="" />
          </div>
        </van-col>
      </van-sticky>
    </van-row>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        style="min-height: 88vh"
        v-model="isLoading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="byg">
          <AdSwiper
            width="710"
            paddingTop="20"
            code="workplace_goodsmanage_01_001"
            groupCode="workplace_goodsmanage_01"
            :refreshing="refreshing"
          />
          <div v-for="(item, index) in list" :key="index">
            <normalItem
              :showButtonVisible="showButtonVisible"
              :item="item"
              @callbackInit="setInit"
              :isBeeGoodsList="isBeeGoodsList"
            />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <Mode ref="mode" @callback="callbackOption"></Mode>
  </div>
</template>
<script>
import http from "@/utils/axios";
import normalItem from "./item";
import Mode from "./mode";
import AdSwiper from "@/components/ad/swiper";
export default {
  name: "beeAdministrate-list-lsit",
  props: {
    // checkStatus: {
    //   type: String,
    //   default: "",
    //   required: false
    // },
    modeShow: {
      type: Boolean,
      default: false,
      required: false,
    },
    isBeeGoodsList: {
      type: Boolean,
      default: false,
      required: false,
    },
    showButtonVisible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isSuper: false,
      refreshing: false,
      isLoading: false,
      finished: false,
      url: "",
      list: [],
      error: false,
      value: "",
      form: {
        anyCategoryId: "",
        branchNo: "",
        branchNoIn: "",
        categoryId: "",
        checkStatus: "", //WAITING("等待审核"),FINISH("通过"),REJECT("拒绝"),NO_COMMIT("未提交审核");
        goodsName: "",
        isHot: "",
        itemNameLike: "",
        pageIndex: 1,
        pageSize: 20,
        priceRangeMax: "",
        priceRangeMin: "",
        upShelf: "",
        saleOut: "",
        myPublished: "n",
      },
      tabList: [],
    };
  },
  methods: {
    onChange(name, title) {
      //console.log(name)
      this.finished = false;
      this.form.upShelf = "";
      this.form.saleOut = "";
      this.form.checkStatus = name;
      if (name == "FINISH" && title == "出售中") {
        this.form.upShelf = "y";
      }
      if (name == "FINISH" && title == "已下架") {
        this.form.upShelf = "n";
      }
      if (title == "已售罄") {
        this.form.saleOut = "y";
      }
      this.form.pageIndex = 1;
      this.list = [];
      this.onLoad();
    },
    onRefresh(time = 1000) {
      setTimeout(() => {
        this.form.pageIndex = 1;
        this.list = [];
        //恢复不是最后一页
        this.finished = false;
        this.onLoad();
      }, time);
    },
    onLoad() {
      this.isLoading = true;
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
      });
      // 超级蜜蜂默认选择上次选择的品牌
      http({
        url: "order/bees/bees/queryIsSuperBees",
        method: "get",
      })
        .then((rps) => {
          if (rps.code == 200) {
            this.isSuper = rps.data.super;
            // 如果是超级蜜蜂
            if (this.isSuper) {
              http({
                url: "order/bees/superbees/selectBranchList",
                method: "post",
              }).then((res) => {
                if (res.code == 200) {
                  if (res.data.branchIds) {
                    this.$set(this.form, "branchNoIn", res.data.branchIds);
                  } else {
                    var arrs = [];
                    arrs.push(res.data.branchId);
                    this.$set(this.form, "branchNoIn", arrs);
                  }
                  // this.$set(this.form, "branchNoIn", res.data.branchIds);
                }
              });
            }
          }
        })
        .catch((rps) => {});

      setTimeout(() => {
        http({
          url: "order/item/quick/bees/page",
          method: "post",
          parmes: this.form,
        })
          .then((rps) => {
            this.error = false;
            //是否是最后一页
            if (
              rps.pageCount == this.form.pageIndex &&
              this.form.pageIndex != 1
            ) {
              this.finished = true;
            } else {
              if (rps.data.length === 0) {
                this.finished = true;
              } else {
                this.finished = false;
                this.form.pageIndex++;
              }
              this.list = this.list.concat(rps.data);
            }
            this.isLoading = false;
            this.$emit("callback", false);
          })
          .catch((rps) => {
            this.error = true;
            this.isLoading = false;
            this.$emit("callback", false);
          });
      }, 500);
    },
    callbackOption(row) {
      for (const key in row) {
        this.form[key] = row[key];
      }
      this.$emit("callback", true);
      this.setInit();
    },
    modeShowFun() {
      this.$refs["mode"].show = true;
    },
    setInit() {
      this.form.pageIndex = 1;
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    getWordFun(val) {
      this.form.itemNameLike = val;
      this.setInit();
    },
    getStatusCount(count) {
      if (!count) {
        return 0;
      } else if (count > 99) {
        return 99;
      } else {
        return count;
      }
    },
    getTabFun() {
      http({
        url: "order/item/quick/bees/statusCount",
        method: "post",
        parmes: {},
      }).then((rps) => {
        this.tabList = rps.data;
      });
    },
  },
  watch: {},
  created() {
    this.getTabFun();
  },
  mounted() {
    window.reloadData = (res) => {
      //批量下架操作成功好 返回当前页面  刷新当前数据
      if (typeof res === "string") {
        res = JSON.parse(res);
      }
      if (res && res.status === "off-shelves-success") {
        this.getTabFun();
        this.onRefresh(0);
      }
    };
  },
  components: { normalItem, Mode, AdSwiper },
};
</script>
<style lang="less" scoped>
.header {
  height: 90px;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  align-items: center;
  .go-l {
    margin-left: -20px;
  }
  .go1 {
    height: 90px;
    line-height: 90px;
    text-align: left;
    // border: 1px solid red;
  }
  .go1-1 {
    width: 592px;
    margin-left: -100px;
    position: relative;
  }
  .go1-2 {
    text-align: left;
    position: relative;
    margin-left: -60px;
  }
}
.go2 {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #fff9e1;
  color: #f8a651;
  height: 70px;
  line-height: 70px;
  font-size: 24px;
}
.pageIndex {
  overflow: hidden;
  .pageIndex-1 {
    // border: 1px solid red;
    overflow: hidden;
  }
  .pageIndex-1 > li {
    overflow: hidden;
    display: inline-block;
    margin-right: 18px;
  }
  .pageIndex-1 > li:nth-child(even) {
    display: inline-block;
    margin-right: 0;
  }
}
.go3 {
  padding: 20px 30px;
  font-size: 26px;
  .go3-0 {
    height: 581px;
    width: 336px;
    .go3-1 {
      min-width: 336px;
      min-height: 396px;
    }
    .go3-2 {
      max-width: 334px;
      padding: 20px;
      border: 1px solid #f2f2f2;
      margin-top: -10px;
      border-top: 0;
      .go3-2-1 {
        max-width: 300px;
        min-height: 75px;
        margin-bottom: 18px;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .go3-2-2 {
        display: flex;
        text-align: left;
        .go3-2-2-1 {
          text-align: left;
          color: #e83636;
          height: 37px;
          line-height: 37px;
          width: 50%;
        }
        .go3-2-2-2 {
          text-align: right;
          width: 50%;
        }
      }
    }
  }
}
.sbar-0 {
  display: flex;
}
/deep/.van-info {
  display: block;
  color: #f8a651;
  background: #fff;
  border: 2px solid #f8a651;
  height: 34px;
  width: 34px;
  font-size: 20px;
  line-height: 34px !important;
  min-width: 0 !important;
  font-weight: 500;
  padding: 0;
  box-sizing: border-box;
  border-radius: 50%;
}
/deep/.van-tabs__line {
  font-size: 26px;
  color: #333333;
  background-color: rgb(248, 213, 65);
}
.sbar-2 {
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  background: rgba(255, 255, 255, 1);
  height: 90px;
  line-height: 90px;
  position: relative;
  img {
    position: absolute;
    top: 50%;
    right: 0;
    z-index: 2;
    width: 40px;
    height: 40px;
    margin-top: -20px;
  }
}
/deep/[class*="van-hairline"]::after {
  border: 0;
}
</style>